import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import MessagePreview from '../restaurants/MessagePreview';
import CouponPreview from '../restaurants/CouponPreview';

// import './TextMessageFormTwoStyle.css';
import { useDropzone } from 'react-dropzone';
// import debounce from 'lodash/debounce';

const MAX_MESSAGE_LENGTH = 160;
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

function WelcomeTextPage() {
  const [formData, setFormData] = useState({
    // title: '',
    content: '',
    // scheduledDate: new Date(),
    // recurrence: 'none',
    // selectedRecipients: [],
    // expirationDate: '',
    isActive: false,
    messageType: 'text',
    image: null,
    expirationDays: '', // New field for expiration days
  });
  // const [customers, setCustomers] = useState([]);
  const [optOutWord, setOptOutWord] = useState('');
  // const [searchTerm, setSearchTerm] = useState('');
  // const [allSelected, setAllSelected] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  // const [messageStatus, setMessageStatus] = useState('');

  //   const { restaurantId, messageId, action } = useParams();
  const { restaurantId } = useParams();
  const navigate = useNavigate();

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles[0]) {
      setFormData((prev) => ({ ...prev, image: acceptedFiles[0] }));
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'image/gif': ['.gif'],
    },
    multiple: false,
  });

  const handleInputChange = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  // const handleInputChange = useCallback((field, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [field]:
  //       field === 'expirationDays'
  //         ? value === ''
  //           ? ''
  //           : parseInt(value) || ''
  //         : value,
  //   }));
  // }, []);

  // const handleDateChange = useCallback(
  //   (date) => {
  //     const now = new Date();
  //     if (date < now) {
  //       now.setMinutes(now.getMinutes() + 1);
  //       now.setSeconds(0);
  //       now.setMilliseconds(0);
  //       handleInputChange('scheduledDate', now);
  //     } else {
  //       handleInputChange('scheduledDate', date);
  //     }
  //   },
  //   [handleInputChange]
  // );

  // const handleMessageTypeChange = useCallback((type) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     messageType: type,
  //     expirationDate: type === 'text' ? '' : prev.expirationDate,
  //   }));
  // }, []);
  const handleMessageTypeChange = useCallback((type) => {
    setFormData((prev) => ({
      ...prev,
      messageType: type,
      expirationDays: type === 'text' ? '' : prev.expirationDays,
    }));
  }, []);

  //   const fetchWelcomeMessage = async () => {
  //     try {
  //       const token = localStorage.getItem('ownerToken');

  //       const response = await axios.get(
  //         `/api/restaurants/${restaurantId}/welcome-text`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );
  //       setContent(response.data.content);
  //       setIsActive(response.data.isActive);
  //     } catch (error) {
  //       if (error.response && error.response.status !== 404) {
  //         // console.error('Error fetching welcome message:', error);
  //         toast.error('Failed to load welcome text.');

  //         setError('Failed to fetch welcome message');
  //       }
  //     }
  //   };

  const fetchData = useCallback(async () => {
    try {
      const token = localStorage.getItem('ownerToken');
      const [welcomeResponse, restaurantResponse] = await Promise.all([
        api.get(`/restaurants/${restaurantId}/welcome-text`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        api.get(`/restaurants/${restaurantId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      const message = welcomeResponse.data;

      //   console.log(message);
      //   console.log(restaurantResponse.data);
      //   setOptOutWord(restaurantResponse.data.optOutWord);
      setOptOutWord(restaurantResponse.data.optOutWord || '');

      setFormData((prev) => ({
        ...prev,
        content: message?.content || '',
        messageType: message?.messageType || 'text',
        image: message?.imageUrl || null,
        isActive: message?.isActive || false,
        expirationDays: message?.expirationDays || '', // Add this line
      }));
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to fetch data. Please try again.');
    }
  }, [restaurantId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  //   await axios.post(
  //     `/api/restaurants/${restaurantId}/welcome-text`,
  //     {
  //       content,
  //       isActive,
  //     },
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    if (!formData.content.trim()) {
      setError(
        'Please fill in all required fields and select at least one recipient'
      );
      setIsSubmitting(false);
      return;
    }

    try {
      const messageData = {
        ...formData,
        restaurantId,
        // originalMessageId: messageId,
        // existingImageKey:
        //   formData.image && !formData.image.name
        //     ? formData.image.split('/').pop()
        //     : null,
      };

      if (formData.image instanceof File) {
        messageData.image = formData.image;
      } else if (typeof formData.image === 'string') {
        messageData.existingImageUrl = formData.image;
      }

      const token = localStorage.getItem('ownerToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      };

      //   if (messageId) {
      //     await api.patch(
      //       `/restaurants/${restaurantId}/messages/${messageId}`,
      //       messageData,
      //       { headers }
      //     );
      //     toast.success('Scheduled message updated successfully');
      //   } else {
      //   await api.post(`/restaurants/${restaurantId}/messages/`, messageData, {
      //     headers,
      //   });

      await axios.post(
        `/api/restaurants/${restaurantId}/welcome-text`,
        messageData,
        { headers }
      );
      toast.success('New message scheduled successfully');
      //   }

      navigate(`/restaurant/${restaurantId}/welcometext`);
    } catch (error) {
      console.error('Error processing text message:', error);
      setError(
        error.response?.data?.message || 'Error processing text message'
      );
      toast.error('Error processing text message');
    } finally {
      setIsSubmitting(false);
    }
  };

  // const calculateExpirationDate = (days) => {
  //   if (!days) return null;
  //   const date = new Date();
  //   date.setDate(date.getDate() + parseInt(days));
  //   return date;
  // };
  const calculateExpirationDate = (days) => {
    if (!days || isNaN(parseInt(days))) return null;
    const date = new Date();
    date.setDate(date.getDate() + parseInt(days));
    return date;
  };

  return (
    <div className='max-w-4xl mx-auto mt-10 px-4'>
      {/* <h2 className='text-2xl font-bold mb-4'>Welcome Text</h2>
      <h2 className='text-md font-bold mb-4 text-gray-500'>
        Setup text message to send when customer first subscribes{' '}
      </h2> */}

      <div className='flex justify-between items-center mb-6'>
        <div>
          <h1 className='text-3xl font-bold'>Welcome Message </h1>

          <h2 className='text-xl text-gray-600 mt-2'>
            Setup text message to send when customer first subscribes
          </h2>
        </div>
        <Link
          to={`/restaurant/${restaurantId}/welcometext/view`}
          className=' bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-800 transition duration-300 ease-in-out shadow-md text-nowrap'
        >
          View All{' '}
        </Link>
      </div>

      {/* <div className='flex flex-col md:flex-row md:space-x-8'> */}
      <div className='flex flex-wrap gap-6 space-y-8 min'>
        <form onSubmit={handleSubmit} className='space-y-4 flex-1'>
          {/* Form fields */}

          <div className='mt-4'>
            <div className='flex justify-between'>
              <label
                htmlFor='content'
                className='block text-sm font-medium text-gray-700'
              >
                Message/Coupon Content
              </label>
              <div className='text-right text-sm text-gray-500'>
                {formData.content.length}/{MAX_MESSAGE_LENGTH}
              </div>
            </div>
            <textarea
              id='content'
              value={formData.content}
              onChange={(e) => handleInputChange('content', e.target.value)}
              required
              rows='4'
              className='w-full p-2 rounded border'
              maxLength={MAX_MESSAGE_LENGTH}
            />
          </div>

          <div>
            <label className='block text-sm font-medium text-gray-700'>
              Message Type:
            </label>
            <div className='mt-2'>
              <label className='inline-flex items-baseline mr-4'>
                <input
                  type='radio'
                  value='text'
                  checked={formData.messageType === 'text'}
                  onChange={() => handleInputChange('messageType', 'text')}
                  className='form-radio'
                />
                <span className='ml-2'>Text</span>
              </label>
              <label className='block text-sm font-medium text-gray-400'>
                Send news, promo code, or events.
              </label>
              <label className='inline-flex items-baseline'>
                <input
                  type='radio'
                  value='coupon'
                  checked={formData.messageType === 'coupon'}
                  //   onChange={() => handleInputChange('messageType', 'coupon')}

                  onChange={() => handleMessageTypeChange('coupon')}
                  className='form-radio'
                />
                <span className='ml-2'>Text + Coupon</span>
              </label>
              <label className='block text-sm font-medium text-gray-400'>
                Generate unique one-time coupon for each subscriber.
              </label>
            </div>
          </div>

          <div className='mb-4'>
            {/* <label className='block text-sm font-medium text-gray-700'>
              Coupon Expiration:
            </label> */}
            {/* <div className='flex max-sm:flex-wrap gap-1'> */}
            <div className='flex flex-col gap-1 w-full'>
              <div className=''>
                <label className='block text-sm font-medium text-gray-700 text-nowrap'>
                  Coupon Expiration Days:
                </label>
                <input
                  type='number'
                  value={formData.expirationDays}
                  onChange={(e) =>
                    handleInputChange('expirationDays', e.target.value)
                  }
                  onWheel={(e) => e.target.blur()}
                  className='w-full p-2 border border-gray-300 rounded'
                  min='0'
                />
              </div>
              <div className=''>
                <label className='block text-sm font-medium text-gray-700 text-nowrap'>
                  Coupon Expiration Date:
                </label>
                {/* <p className='w-full p-2 border border-gray-300 rounded'>
                  {calculateExpirationDate(
                    formData.expirationDays
                  )?.toLocaleDateString() || ''}
                </p> */}
                <input
                  type='text'
                  className='w-full p-2 border border-gray-300 rounded'
                  value={
                    calculateExpirationDate(
                      formData.expirationDays
                    )?.toLocaleDateString() || ''
                  }
                  disabled
                />
              </div>
            </div>
          </div>
          {/* 
          {formData.messageType === 'coupon' && (
            <div className='mb-4'>
              <label className='block text-sm font-medium text-gray-700'>
                Coupon Expiration (days after send):
              </label>
              <input
                type='number'
                value={formData.expirationDays}
                onChange={(e) =>
                  handleInputChange('expirationDays', e.target.value)
                }
                className='w-full p-2 border border-gray-300 rounded'
                min='0'
              />
            </div>
          )}

          {formData.messageType === 'coupon' && formData.expirationDays && (
            <div className='mt-4'>
              <label className='block text-sm font-medium text-gray-700'>
                Coupon Expiration Date:
              </label>
              <p className='text-sm text-gray-600'>
                {calculateExpirationDate(
                  formData.expirationDays
                )?.toLocaleDateString() || 'Not set'}
              </p>
            </div>
          )} */}

          <div className='mb-4'>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Upload Image (Optional)
            </label>
            <div
              {...getRootProps()}
              className={`dropzone border-2 border-dashed rounded-lg p-4 text-center cursor-pointer transition-colors duration-200 ease-in-out ${
                isDragActive
                  ? 'border-indigo-600 bg-indigo-50'
                  : 'border-gray-300 hover:border-indigo-400'
              }`}
            >
              <input {...getInputProps()} />
              {isDragActive ? (
                <p className='text-indigo-600'>Drop the image here ...</p>
              ) : (
                <div>
                  <p className='text-gray-600'>
                    Drag 'n' drop an image here, or click to select one
                  </p>
                  <p className='text-sm text-gray-500 mt-1'>
                    Supported formats: JPG, PNG, GIF
                  </p>
                </div>
              )}
            </div>

            {formData.image && (
              <div className='mt-2 flex items-center'>
                <span className='text-sm text-gray-600'>
                  {formData.image instanceof File
                    ? formData.image.name
                    : 'Current image'}
                </span>
                <button
                  type='button'
                  onClick={() => handleInputChange('image', null)}
                  className='ml-2 text-red-600 hover:text-red-800 text-sm'
                >
                  Remove
                </button>
              </div>
            )}
          </div>
          <div className='flex items-center'>
            <input
              type='checkbox'
              id='isActive'
              //   checked={isActive}
              //   onChange={(e) => setIsActive(e.target.checked)}
              checked={formData.isActive}
              onChange={(e) => handleInputChange('isActive', e.target.checked)}
              className='h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded'
            />
            <label
              htmlFor='isActive'
              className='ml-2 block text-sm text-gray-900'
            >
              Active
            </label>
          </div>
          {error && <p className='text-red-500 mt-2'>{error}</p>}

          {/* <button
            type='submit'
            className='bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:bg-indigo-300'
            disabled={isSubmitting}
          >
            Save Welcome Text
          </button> */}

          <button
            type='submit'
            className='bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 disabled:bg-indigo-300 text-nowrap'
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Processing...' : 'Save Welcome Text'}
          </button>
        </form>

        <div className='flex-1 mt-8 md:mt-0'>
          <MessagePreview
            content={formData.content}
            messageType={formData.messageType}
            // expirationDate={formData.expirationDate}
            optOutWord={optOutWord}
            image={formData.image}
            // messageId={messageId}
          />
          {formData.messageType === 'coupon' && (
            <>
              {/* <h3 className='text-lg font-semibold mt-8 mb-4'>
                Coupon Preview
              </h3> */}
              <CouponPreview
                content={formData.content}
                // expirationDate={formData.expirationDate}
                expirationDate={
                  formData.messageType === 'coupon'
                    ? calculateExpirationDate(formData.expirationDays)
                    : null
                }
                messageType={formData.messageType}
              />
            </>
          )}
          {formData.image && (
            <div className='mt-4'>
              <h3 className='text-lg font-semibold mb-2'>Image Preview</h3>
              <img
                src={
                  formData.image instanceof File
                    ? URL.createObjectURL(formData.image)
                    : formData.image
                }
                alt='Uploaded preview'
                className='max-w-full h-auto rounded-lg shadow-md'
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(WelcomeTextPage);
